/**
 * Listagem (categoria e busca) — porte do comportamento de Mageplaza_AjaxLayer/templates/layer/
 * view.phtml da produção:
 *  - filtros em acordeão (desktop fecha os outros ao abrir um; clique fora fecha), "VER MAIS"
 *    no celular (8 opções), busca dentro das opções;
 *  - gaveta de filtros no celular (Filtrar / × / Esc / overlay; "Ver N vinhos" fecha);
 *  - categoria: cada seleção recarrega a listagem na hora (sem recarregar a página), como a engine
 *    de filtros da produção; busca: marca várias e aplica (como na produção);
 *  - preço (mín./máx. + Aplicar), ordenação, itens por página (?view=12|36) e paginação;
 *  - categoria: opções dos filtros só com vinhos em estoque, esmaecidas quando zeram na combinação
 *    (ver "Opções com estoque" abaixo).
 * A listagem vem da Section Rendering API; a URL da página acompanha (pushState / voltar).
 */
(function () {
  'use strict';

  if (window.VvCollection) return;

  var ROOT_SEL = '[data-vv-listing]';
  var BLOCK_SEL = '#layered-filter-block';
  var MOBILE_LIMIT = 8;
  var isDesktop = function () { return window.innerWidth >= 992; };

  function root() { return document.querySelector(ROOT_SEL); }
  function sectionEl() { var r = root(); return r && r.closest('.shopify-section'); }

  /* ── Estado visual ── */
  function setOpen(item, open) {
    ['is-open', 'active', 'allow'].forEach(function (c) { item.classList.toggle(c, open); });
  }

  function applyShowMore() {
    var desktop = isDesktop();
    document.querySelectorAll(BLOCK_SEL + ' .vv-filter-item[data-vv-filter-limit]').forEach(function (item) {
      var list = item.querySelectorAll('.filter-options-content ol li');
      var btn = item.querySelector('.vv-filter-more');
      var limit = parseInt(item.getAttribute('data-vv-filter-limit'), 10) || MOBILE_LIMIT;
      if (desktop || list.length <= limit) {
        list.forEach(function (li) { li.classList.remove('vv-filter-hidden'); });
        if (btn) btn.remove();
        item.removeAttribute('data-vv-shown');
        return;
      }
      var shown = parseInt(item.getAttribute('data-vv-shown'), 10);
      if (isNaN(shown) || shown < limit) shown = limit;
      if (shown > list.length) shown = list.length;
      item.setAttribute('data-vv-shown', shown);
      list.forEach(function (li, i) { li.classList.toggle('vv-filter-hidden', i >= shown); });
      if (shown >= list.length) {
        if (btn) btn.remove();
      } else if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vv-filter-more';
        btn.textContent = (window.VvCollectionStrings && window.VvCollectionStrings.more) || 'VER MAIS';
        item.querySelector('.vv-filter-body').appendChild(btn);
      }
    });
  }

  /* ── URL ── */
  function currentUrl() { return new URL(window.location.href); }

  function withParams(mutator) {
    var url = currentUrl();
    mutator(url.searchParams);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
  }

  // Limpa os filtros escolhidos; o "só disponíveis" da busca (options[unavailable_products]) fica, como na produção
  function clearFiltersUrl() {
    return withParams(function (p) {
      Array.from(p.keys()).forEach(function (k) {
        if (k.indexOf('filter.') === 0) p.delete(k);
      });
    });
  }

  // Busca (modo "Aplicar"): monta a URL com todas as opções marcadas
  function buildApplyUrl() {
    return withParams(function (p) {
      var attrs = {};
      document.querySelectorAll(BLOCK_SEL + ' .vv-filter-input').forEach(function (cb) {
        attrs[cb.getAttribute('data-attr')] = true;
      });
      Object.keys(attrs).forEach(function (a) { p.delete(a); });
      document.querySelectorAll(BLOCK_SEL + ' .vv-filter-input:checked').forEach(function (cb) {
        p.append(cb.getAttribute('data-attr'), cb.getAttribute('data-value'));
      });
      var wrap = document.querySelector(BLOCK_SEL + ' [data-vv-price-range]');
      if (wrap) priceParams(wrap, p);
    });
  }

  function priceParams(wrap, p) {
    var f = parseFloat(wrap.querySelector('.vv-price-range-from').value);
    var t = parseFloat(wrap.querySelector('.vv-price-range-to').value);
    var min = parseFloat(wrap.getAttribute('data-min') || '0');
    var max = parseFloat(wrap.getAttribute('data-max') || '0');
    var pMin = wrap.getAttribute('data-param-min');
    var pMax = wrap.getAttribute('data-param-max');
    p.delete(pMin);
    p.delete(pMax);
    if (isNaN(f) || isNaN(t)) return;
    if (f > t) { var x = f; f = t; t = x; }
    if (f > min) p.set(pMin, String(Math.floor(f)));
    if (t < max) p.set(pMax, String(Math.ceil(t)));
  }

  /* ── Opções com estoque (categoria) ──
     O Shopify lista os valores de todos os produtos da coleção, inclusive esgotados, e corta em 100
     por filtro. Na produção as opções contam só os vinhos em estoque, sem limite, e as que zeram na
     combinação escolhida ficam esmaecidas. As listas são montadas aqui com os vinhos disponíveis da
     coleção (templates/collection.vv-facets.liquid, que segue os filtros configurados no Search &
     Discovery), na mesma marcação do Liquid; se os dados não vierem, ficam as listas do Shopify. */
  var FACETS_TTL = 10 * 60 * 1000;
  var facetCache = {};
  var facetSeq = 0;

  // { keys, rows } do template → { keys, products: [{ price, v: { filtro: [valores] } }], labels }.
  // Valor de metaobject vem como [id, nome]: o filtro usa o id, a lista mostra o nome.
  function parseFacets(raw) {
    var labels = {};
    var list = function (x) {
      if (x == null || x === '') return [];
      if (Array.isArray(x) && Array.isArray(x[0])) {
        return x.map(function (pair) { labels[pair[0]] = pair[1]; return String(pair[0]); });
      }
      return [].concat(x).map(String);
    };
    var products = raw.rows.map(function (r) {
      var v = {};
      raw.keys.forEach(function (k, i) { v[k] = list(r[i + 1]); });
      return { price: r[0] / 100, v: v };
    });
    return { keys: raw.keys, products: products, labels: labels };
  }

  function fetchFacets(base) {
    // A assinatura (filtros da página) renova o cache quando a configuração do app muda
    var sig = Array.prototype.map.call(document.querySelectorAll(BLOCK_SEL + ' .vv-filter-item[attribute]'), function (it) {
      return it.getAttribute('attribute');
    }).join(',');
    var key = 'vv-facets:' + base + '|' + sig;
    if (facetCache[key]) return facetCache[key];
    try {
      var saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && saved.keys && Date.now() - saved.t < FACETS_TTL) return (facetCache[key] = Promise.resolve(parseFacets(saved)));
    } catch (e) {}
    var get = function (page) {
      return fetch(base + '?view=vv-facets&filter.v.availability=1&page=' + page, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        });
    };
    facetCache[key] = get(1).then(function (first) {
      var rest = [];
      for (var p = 2; p <= first.pages; p++) rest.push(get(p));
      return Promise.all(rest).then(function (pages) {
        var raw = { t: Date.now(), keys: first.keys, rows: pages.reduce(function (all, pg) { return all.concat(pg.products); }, first.products) };
        try { sessionStorage.setItem(key, JSON.stringify(raw)); } catch (e) {}
        return parseFacets(raw);
      });
    });
    facetCache[key].catch(function () { delete facetCache[key]; });
    return facetCache[key];
  }

  function facetState(params, keys) {
    var st = { keys: keys, act: {}, gte: parseFloat(params.get('filter.v.price.gte')), lte: parseFloat(params.get('filter.v.price.lte')) };
    keys.forEach(function (k) { st.act[k] = params.getAll(k); });
    return st;
  }

  // O vinho conta para o filtro `skip` se atende aos OUTROS filtros escolhidos e ao preço
  // (dentro de um mesmo filtro as opções somam, como no Shopify e na produção)
  function facetMatch(prod, st, skip) {
    if (!isNaN(st.gte) && prod.price < st.gte) return false;
    if (!isNaN(st.lte) && prod.price > st.lte) return false;
    return st.keys.every(function (k) {
      var sel = st.act[k];
      return k === skip || !sel.length || prod.v[k].some(function (x) { return sel.indexOf(x) > -1; });
    });
  }

  function toggleParam(url, key, val, on) {
    var u = new URL(url.href);
    var keep = u.searchParams.getAll(key).filter(function (x) { return x !== val; });
    u.searchParams.delete(key);
    keep.forEach(function (x) { u.searchParams.append(key, x); });
    if (!on) u.searchParams.append(key, val);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    return u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');
  }

  function renderFacet(item, key, data, st, url) {
    var ol = item.querySelector('.filter-options-content ol.items');
    if (!ol) return;
    var total = {};
    var live = {};
    data.products.forEach(function (prod) {
      var vals = prod.v[key];
      if (!vals.length) return;
      var ok = facetMatch(prod, st, key);
      vals.forEach(function (x) {
        total[x] = (total[x] || 0) + 1;
        if (ok) live[x] = (live[x] || 0) + 1;
      });
    });
    var active = st.act[key];
    var label = function (x) { return data.labels[x] || x; };
    var values = Object.keys(total);
    active.forEach(function (a) { if (!total[a]) values.push(a); });
    // Marcados primeiro; depois por quantidade de vinhos em estoque (como na produção)
    values.sort(function (a, b) {
      var aa = active.indexOf(a) > -1;
      var bb = active.indexOf(b) > -1;
      if (aa !== bb) return aa ? -1 : 1;
      return (total[b] || 0) - (total[a] || 0) || label(a).localeCompare(label(b), 'pt-BR');
    });
    ol.innerHTML = values.map(function (x) {
      var on = active.indexOf(x) > -1;
      var off = !on && !live[x];
      return '<li class="item"><label class="vv-filter-option' + (on ? ' vv-checked' : '') + (off ? ' vv-filter-option--unavailable' : '') + '">'
        + '<input type="checkbox" class="vv-filter-input" data-attr="' + escapeHtml(key) + '" data-value="' + escapeHtml(x)
        + '" data-url="' + escapeHtml(toggleParam(url, key, x, on)) + '"' + (on ? ' checked' : '') + (off ? ' disabled' : '') + '>'
        + '<span class="vv-filter-checkbox' + (on ? ' is-checked' : '') + '" aria-hidden="true"></span>'
        + '<span class="vv-filter-label">' + escapeHtml(label(x)) + '</span></label></li>';
    }).join('');
    // Sem vinho em estoque com esse atributo: o filtro some (na produção ficava aberto e vazio)
    item.style.display = values.length ? '' : 'none';
  }

  function applyFacets(href) {
    var r = root();
    var base = r && r.getAttribute('data-vv-facets');
    if (!base) return;
    var seq = ++facetSeq;
    fetchFacets(base).then(function (data) {
      if (seq !== facetSeq) return;
      var url = new URL(href || window.location.href, document.baseURI);
      var st = facetState(url.searchParams, data.keys);
      document.querySelectorAll(BLOCK_SEL + ' .vv-filter-item[attribute]').forEach(function (item) {
        var key = item.getAttribute('attribute');
        if (data.keys.indexOf(key) > -1) renderFacet(item, key, data, st, url);
      });
      applyShowMore();
    }).catch(function () {});
  }

  /* ── Troca da listagem (Section Rendering API) ── */
  var controller = null;

  // Disponíveis primeiro (ajuste 01 de 08/10/2026): com uma ordenação diferente da padrão da coleção a
  // listagem pagina os vinhos em estoque (filter.v.availability=1) e depois os esgotados (=0) — ver
  // snippets/vv-m-listing.liquid. Ordem ou filtros novos (URL sem página) recomeçam na fase 1; na ordem
  // padrão o parâmetro sai (lá os esgotados já ficam no fim).
  function phaseUrl(url) {
    var r = root();
    if (!r || !r.hasAttribute('data-vv-default-sort')) return url;
    var u = new URL(url, window.location.origin);
    var sort = u.searchParams.get('sort_by');
    if (sort && sort !== r.getAttribute('data-vv-default-sort')) {
      if (!u.searchParams.has('page')) u.searchParams.set('filter.v.availability', '1');
    } else {
      u.searchParams.delete('filter.v.availability');
    }
    return u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');
  }

  // Mantém o "itens por página" (?view=12|36) nas URLs geradas pelo Shopify (filtros, paginação)
  function keepView(url) {
    var view = currentUrl().searchParams.get('view');
    if (!view) return url;
    var u = new URL(url, window.location.origin);
    if (!u.searchParams.has('view')) u.searchParams.set('view', view);
    return u.pathname + '?' + u.searchParams.toString();
  }

  function load(url, opts) {
    opts = opts || {};
    url = phaseUrl(url);
    if (!opts.raw) url = keepView(url);
    var section = sectionEl();
    var r = root();
    if (!section || !r) { window.location.href = url; return; }
    var sectionId = r.getAttribute('data-section-id');

    // Guarda o estado visual para reaplicar depois da troca
    var openAttrs = [];
    document.querySelectorAll(BLOCK_SEL + ' .vv-filter-item.is-open').forEach(function (it) {
      openAttrs.push(it.getAttribute('attribute') || (it.classList.contains('vv-filter-item-sort') ? '__sort' : ''));
    });
    var shown = {};
    document.querySelectorAll(BLOCK_SEL + ' .vv-filter-item[data-vv-shown]').forEach(function (it) {
      shown[it.getAttribute('attribute')] = it.getAttribute('data-vv-shown');
    });
    var body = document.querySelector(BLOCK_SEL + ' .vv-filters-body');
    var bodyScroll = body ? body.scrollTop : 0;

    r.classList.add('vv-listing-loading');
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl, controller ? { signal: controller.signal } : {})
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.shopify-section') || doc.body;
        section.innerHTML = fresh.innerHTML;

        openAttrs.forEach(function (a) {
          var sel = a === '__sort' ? '.vv-filter-item-sort' : '.vv-filter-item[attribute="' + a + '"]';
          var it = document.querySelector(BLOCK_SEL + ' ' + sel);
          if (it) setOpen(it, true);
        });
        Object.keys(shown).forEach(function (a) {
          var it = document.querySelector(BLOCK_SEL + ' .vv-filter-item[attribute="' + a + '"]');
          if (it) it.setAttribute('data-vv-shown', shown[a]);
        });
        applyShowMore();
        applyFacets(url);
        var nb = document.querySelector(BLOCK_SEL + ' .vv-filters-body');
        if (nb) nb.scrollTop = bodyScroll;

        // Fase 1 sem nenhum vinho em estoque nos filtros escolhidos: segue direto para os esgotados
        var next = section.querySelector('[data-vv-phase-next]');
        if (next) { load(next.getAttribute('href'), { push: opts.push, replace: true, scroll: opts.scroll }); return; }
        if (opts.replace) history.replaceState({ vvListing: true }, '', url);
        else if (opts.push !== false) history.pushState({ vvListing: true }, '', url);
        if (opts.scroll) {
          // scrollIntoView: no desktop quem rola é o .page-wrapper do Horizon, não a janela
          var grid = document.getElementById('layer-product-list');
          if (grid && grid.getBoundingClientRect().top < 0) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (window.VvMagento) window.VvMagento.init(section);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  window.addEventListener('popstate', function () {
    if (root()) load(window.location.pathname + window.location.search, { push: false });
  });

  /* ── Eventos (delegação: sobrevivem à troca da listagem) ── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    // Abrir/fechar um filtro
    var toggle = t.closest(BLOCK_SEL + ' .vv-filter-toggle');
    if (toggle) {
      e.preventDefault();
      var item = toggle.closest('.vv-filter-item');
      var wasOpen = item.classList.contains('is-open');
      if (isDesktop() && !wasOpen) {
        document.querySelectorAll(BLOCK_SEL + ' .vv-filter-item.is-open').forEach(function (it) { setOpen(it, false); });
      }
      setOpen(item, !wasOpen);
      return;
    }

    // "VER MAIS" (celular): revela todas as opções restantes
    var more = t.closest(BLOCK_SEL + ' .vv-filter-more');
    if (more) {
      e.preventDefault();
      var mi = more.closest('.vv-filter-item');
      mi.querySelectorAll('.filter-options-content ol li').forEach(function (li) { li.classList.remove('vv-filter-hidden'); });
      mi.setAttribute('data-vv-shown', mi.querySelectorAll('.filter-options-content ol li').length);
      more.remove();
      return;
    }

    // Gaveta (celular)
    if (t.closest('[data-vv-open-filters]')) {
      e.preventDefault();
      document.body.classList.add('vv-filters-open');
      return;
    }
    if (t.closest(BLOCK_SEL + ' .vv-filters-close') || t.closest('[data-vv-filters-overlay]')) {
      e.preventDefault();
      document.body.classList.remove('vv-filters-open');
      return;
    }

    // "Ver N vinhos": categoria só fecha (a listagem já está atualizada); busca aplica
    var apply = t.closest(BLOCK_SEL + ' [data-vv-apply-filters]');
    if (apply) {
      e.preventDefault();
      var r = root();
      document.body.classList.remove('vv-filters-open');
      if (r && r.hasAttribute('data-vv-reactive')) {
        var grid = document.getElementById('layer-product-list');
        if (grid && grid.scrollIntoView) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        load(buildApplyUrl());
      }
      return;
    }

    // Preço
    var priceBtn = t.closest(BLOCK_SEL + ' [data-vv-price-apply]');
    if (priceBtn) {
      e.preventDefault();
      var wrap = priceBtn.closest('[data-vv-price-range]');
      load(withParams(function (p) { priceParams(wrap, p); }));
      return;
    }

    // Ordenação
    var sort = t.closest(BLOCK_SEL + ' [data-vv-sort]');
    if (sort) {
      e.preventDefault();
      var v = sort.getAttribute('data-vv-sort');
      load(withParams(function (p) { p.set('sort_by', v); }));
      return;
    }

    // Limpar filtros (mantém busca, ordenação e itens por página)
    var clear = t.closest('[data-vv-clear-filters], ' + ROOT_SEL + ' .vv-filters-clear');
    if (clear) {
      e.preventDefault();
      load(clearFiltersUrl());
      return;
    }

    // Paginação e remoção de filtro ativo
    var link = t.closest(ROOT_SEL + ' [data-vv-listing-link]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault();
      var isPager = !!link.closest('.pages');
      load(link.getAttribute('href'), { scroll: isPager });
      return;
    }

    // Desktop: clique fora de um filtro fecha os abertos
    if (isDesktop() && !t.closest(BLOCK_SEL + ' .vv-filter-item')) {
      document.querySelectorAll(BLOCK_SEL + ' .vv-filter-item.is-open').forEach(function (it) { setOpen(it, false); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches && input.matches(BLOCK_SEL + ' .vv-filter-input')) {
      var label = input.closest('.vv-filter-option');
      var box = label && label.querySelector('.vv-filter-checkbox');
      if (label) label.classList.toggle('vv-checked', input.checked);
      if (box) box.classList.toggle('is-checked', input.checked);
      var r = root();
      if (r && r.hasAttribute('data-vv-reactive')) {
        // Categoria: aplica na hora (URL do Shopify que adiciona/remove esta opção)
        load(input.getAttribute('data-url') || buildApplyUrl());
      }
      return;
    }
    if (input.matches && input.matches(ROOT_SEL + ' [data-vv-limiter]')) {
      var n = input.value;
      load(withParams(function (p) {
        if (n === '24') p.delete('view');
        else p.set('view', n);
      }), { scroll: true, raw: true });
      return;
    }
    // "Ordenar" da barra do celular (lista nativa): mesma troca de ordem dos links do painel de filtros
    if (input.matches && input.matches(ROOT_SEL + ' [data-vv-sort-select]')) {
      var v = input.value;
      if (!v) return;
      load(withParams(function (p) { p.set('sort_by', v); }), { scroll: true });
    }
  });

  // Busca dentro das opções. O Shopify entrega até 100 valores por filtro (os com mais produtos);
  // quando o nome procurado não está entre eles, sugere a página dele (produtor, região, uva…).
  var searchTimer, moreCtrl;
  function escapeHtml(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function suggestPages(input, body, term) {
    if (moreCtrl) moreCtrl.abort();
    moreCtrl = 'AbortController' in window ? new AbortController() : null;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=collection&resources[limit]=4',
      moreCtrl ? { signal: moreCtrl.signal } : {})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        // Só páginas cujo nome contém o termo (a busca do Shopify também traz parecidos)
        var marks = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g'); // acentos (NFD)
        var plain = function (v) { return String(v || '').normalize('NFD').replace(marks, '').toLowerCase(); };
        var found = ((data && data.resources && data.resources.results.collections) || []).filter(function (c) {
          return plain(c.title).indexOf(plain(term)) > -1;
        });
        if (!found.length || (input.value || '').trim() !== term) return;
        var box = document.createElement('div');
        box.className = 'vv-filter-search-more';
        box.innerHTML = '<span>' + escapeHtml(input.getAttribute('data-vv-more') || '') + '</span>'
          + found.map(function (c) { return '<a href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + ' &rarr;</a>'; }).join('');
        body.appendChild(box);
      })
      .catch(function () {});
  }
  document.addEventListener('keyup', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches(BLOCK_SEL + ' .vv-filter-search')) return;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      var term = (input.value || '').trim();
      var q = term.toUpperCase();
      var body = input.closest('.vv-filter-body');
      var items = body.querySelectorAll('ol li');
      var old = body.querySelector('.vv-filter-search-more');
      if (old) old.remove();
      if (!q) {
        items.forEach(function (li) { li.classList.remove('vv-filter-search-hidden'); });
        applyShowMore();
        return;
      }
      var any = false;
      items.forEach(function (li) {
        var match = li.textContent.toUpperCase().indexOf(q) > -1;
        li.classList.toggle('vv-filter-search-hidden', !match);
        if (match) { li.classList.remove('vv-filter-hidden'); any = true; }
      });
      if (!any && term.length >= 3) suggestPages(input, body, term);
    }, 150);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.body.classList.remove('vv-filters-open');
  });

  // Filtros sempre fechados ao trocar de desktop ↔ celular (como na produção)
  var lastDesktop = isDesktop();
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var now = isDesktop();
      if (now !== lastDesktop) {
        lastDesktop = now;
        document.querySelectorAll(BLOCK_SEL + ' .vv-filter-item').forEach(function (it) { setOpen(it, false); });
      }
      applyShowMore();
    }, 200);
  });

  function init() {
    var r = root();
    if (!r) return;
    if (r.hasAttribute('data-vv-reactive')) document.body.classList.add('vv-facets-ready');
    applyShowMore();
    applyFacets();
    // Link compartilhado com ordenação mas sem a fase de estoque, ou fase 1 vazia: corrige no lugar
    var here = window.location.pathname + window.location.search;
    var next = document.querySelector('[data-vv-phase-next]');
    if (next) load(next.getAttribute('href'), { replace: true });
    else if (phaseUrl(here) !== here) load(here, { replace: true });
  }

  window.VvCollection = { load: load, init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
